import enviro from 'enviro';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { RequestStatuses, contentHasTranslations, contentIsArchived, contentIsPublished, contentIsTranslation, getContentPropertyValue, useContentObjectType, contentIsScheduled, CONTENT_PLATFORM_PROPERTY_NAME } from 'content-management-data-lib';
// @ts-ignore Untyped module
import { canAssignTeamsAsNonAdmin } from 'ContentUtils/helpers/TeamsHelpers';
import EditCampaignAction from 'campaigns-lib/campaignsPlatform/CampaignsPlatformEditAction';
import { useAssetActions } from 'asset-actions-lib/context/AssetActionsContext';
import { CONTENT_ACTION_IDS } from '../constants/actionIds';
import AsyncCloneModal from '../modals/AsyncCloneModal';
import MultiStepModals from '../modals/MultiStepModals';
import { ROW_ACTION_GROUPS } from '../constants/actionGroups';
import AsyncArchiveModal from '../modals/AsyncArchiveModal';
import { getHasMultilangVariations } from '../utils/contentUtils';
import AsyncUnarchiveModal from '../modals/AsyncUnarchiveModal';
import AsyncDeleteModal from '../modals/AsyncDeleteModal';
import AsyncRemoveFromLanguageGroupModal from '../modals/AsyncRemoveFromLanguageGroupModal';
import AsyncAddToLanguageGroupModal from '../modals/AsyncAddToLanguageGroupModal';
import AsyncSwitchPrimaryLanguageModal from '../modals/AsyncSwitchPrimaryLanguageModal';
import AsyncConvertToLanguageGroupPrimaryModal from '../modals/AsyncConvertToLanguageGroupPrimaryModal';
import AsyncCreateLanguageVariationModal from '../modals/AsyncCreateLanguageVariationModal';
import AsyncPublishingOptionsModal from '../modals/AsyncPublishingOptionsModal';
import AsyncUnpublishingOptionsModal from '../modals/AsyncUnpublishingOptionsModal';
import AsyncAssignPermissionsPanel from '../modals/AsyncAssignPermissionsPanel';
import AsyncContentAccessControlPanel from '../modals/AsyncContentAccessControlPanel';
import { getBulkAddToLanguageGroupDisabledTooltipKey, getLimitReachedDisabledTooltipKey, getHasCrmObjectsWithOnlyPrimarySelected, getIsEntireMlangGroupSelected } from '../utils/disabledActionsUtils';
import { WithUpdateDomainLanguageModal } from '../modals/WithUpdateDomainLanguageModal';
import { ArchiveIcon } from 'foundations-assets/icons/components/ArchiveIcon';
import { DeleteIcon } from 'foundations-assets/icons/components/DeleteIcon';
import { EditIcon } from 'foundations-assets/icons/components/EditIcon';
import { LanguageIcon } from 'foundations-assets/icons/components/LanguageIcon';
import { ListsIcon } from 'foundations-assets/icons/components/ListsIcon';
import { PublishIcon } from 'foundations-assets/icons/components/PublishIcon';
import { UnarchiveIcon } from 'foundations-assets/icons/components/UnarchiveIcon';
import { UnpublishIcon } from 'foundations-assets/icons/components/UnpublishIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const DisabledBulkActionTooltip = ({
  langKey
}) => {
  const {
    contentObjectTypePluralNoun,
    contentObjectTypeSingularNoun
  } = useContentObjectType();
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: langKey,
    options: {
      contentObjectTypePluralNoun,
      contentObjectTypeSingularNoun
    }
  });
};
const DisabledDueToLimitsTooltip = ({
  langKey,
  multiLangGroupSizeLimit
}) => {
  const {
    contentObjectTypePluralNoun,
    contentObjectTypeSingularNoun,
    contentGroupObjectTypePluralNoun,
    contentGroupObjectTypeSingularNoun
  } = useContentObjectType();
  if (!langKey) {
    return null;
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: `content-management-actions-lib.tooltips.disabledActions.usageLimits.${langKey}`,
    options: {
      contentObjectTypePluralNoun,
      contentObjectTypeSingularNoun,
      contentGroupObjectTypePluralNoun,
      contentGroupObjectTypeSingularNoun,
      multiLangGroupSizeLimit
    }
  });
};
export const getActionName = actionId => /*#__PURE__*/_jsx(FormattedMessage, {
  message: `content-management-actions-lib.actions.${actionId}`
});
const CONTENT_EDIT = {
  id: CONTENT_ACTION_IDS.EDIT,
  name: getActionName(CONTENT_ACTION_IDS.EDIT),
  onActionButtonClick: () => {
    if (enviro.isQa()) {
      console.error("[ERROR]: Must override `onActionButtonClick` for `CONTENT_ACTION_IDS.EDIT` action's config to navigate users to your content type's editor app");
    }
  }
};
const CONTENT_CLONE = {
  id: CONTENT_ACTION_IDS.CLONE,
  name: getActionName(CONTENT_ACTION_IDS.CLONE),
  tableRowActionGroup: ROW_ACTION_GROUPS.BASIC,
  ModalOrPanel: AsyncCloneModal
};
const CONTENT_VIEW = {
  id: CONTENT_ACTION_IDS.VIEW,
  name: getActionName(CONTENT_ACTION_IDS.VIEW),
  tableRowActionGroup: ROW_ACTION_GROUPS.BASIC,
  onActionButtonClick: () => {
    if (enviro.isQa()) {
      console.error("[ERROR]: Must override `onActionButtonClick` for `CONTENT_ACTION_IDS.VIEW` action's config to navigate users to your content's preview");
    }
  }
};
const CONTENT_DETAILS = {
  id: CONTENT_ACTION_IDS.DETAILS,
  name: getActionName(CONTENT_ACTION_IDS.DETAILS),
  tableRowActionGroup: ROW_ACTION_GROUPS.BASIC,
  onActionButtonClick: () => {
    if (enviro.isQa()) {
      console.error("[ERROR]: Must override `onActionButtonClick` for `CONTENT_ACTION_IDS.DETAILS` action's config to navigate users to your content type's details page app");
    }
  }
};
const CONTENT_ADD_TO_LANGUAGE_GROUP = {
  id: CONTENT_ACTION_IDS.ADD_TO_LANGUAGE_GROUP,
  name: getActionName(CONTENT_ACTION_IDS.ADD_TO_LANGUAGE_GROUP),
  tableRowActionGroup: ROW_ACTION_GROUPS.MULTI_LANG,
  ModalOrPanel: props => /*#__PURE__*/_jsx(WithUpdateDomainLanguageModal, Object.assign({
    MultiLangActionModal: AsyncAddToLanguageGroupModal
  }, props)),
  isAvailableAsBulkAction: true,
  BulkInlineActionIcon: LanguageIcon,
  displayPermissions: {
    custom: ({
      crmObjects,
      isBulkAction
    }) => {
      if (!isBulkAction && crmObjects.length > 0) {
        return !contentHasTranslations(crmObjects[0]) && !contentIsTranslation(crmObjects[0]);
      }
      return true;
    }
  },
  enablePermissions: {
    custom: ({
      crmObjects,
      isBulkAction,
      permissionsExtraData
    }) => {
      if (isBulkAction) {
        const disabledBulkActionTooltipKey = getBulkAddToLanguageGroupDisabledTooltipKey(crmObjects);
        return !disabledBulkActionTooltipKey;
      }
      if (permissionsExtraData && permissionsExtraData.limitData) {
        const limitTooltip = getLimitReachedDisabledTooltipKey({
          limitData: permissionsExtraData.limitData,
          crmObjects
        });
        return !limitTooltip;
      }
      return true;
    }
  },
  DisabledTooltipContent: ({
    crmObjects,
    permissionsExtraData
  }) => {
    const disabledBulkActionTooltipKey = getBulkAddToLanguageGroupDisabledTooltipKey(crmObjects);
    if (disabledBulkActionTooltipKey) {
      return /*#__PURE__*/_jsx(DisabledBulkActionTooltip, {
        langKey: `content-management-actions-lib.tooltips.disabledBulkActions.addToLanguageGroup.${disabledBulkActionTooltipKey}`
      });
    }
    const limitTooltipKey = getLimitReachedDisabledTooltipKey({
      limitData: permissionsExtraData.limitData,
      crmObjects
    });
    return /*#__PURE__*/_jsx(DisabledDueToLimitsTooltip, {
      langKey: limitTooltipKey
    });
  }
};
const CONTENT_CREATE_LANGUAGE_VARIANT = {
  id: CONTENT_ACTION_IDS.CREATE_LANGUAGE_VARIANT,
  name: getActionName(CONTENT_ACTION_IDS.CREATE_LANGUAGE_VARIANT),
  tableRowActionGroup: ROW_ACTION_GROUPS.MULTI_LANG,
  ModalOrPanel: props => /*#__PURE__*/_jsx(WithUpdateDomainLanguageModal, Object.assign({
    MultiLangActionModal: AsyncCreateLanguageVariationModal
  }, props)),
  displayPermissions: {
    custom: ({
      crmObjects
    }) => {
      return crmObjects.length > 0 && !contentIsTranslation(crmObjects[0]);
    }
  },
  enablePermissions: {
    custom: ({
      permissionsExtraData,
      crmObjects
    }) => {
      if (permissionsExtraData && permissionsExtraData.limitData) {
        const limitTooltip = getLimitReachedDisabledTooltipKey({
          limitData: permissionsExtraData.limitData,
          crmObjects,
          canBeDisabledDueToMultiLangLimits: true
        });
        return !limitTooltip;
      }
      return true;
    }
  },
  DisabledTooltipContent: ({
    crmObjects,
    permissionsExtraData
  }) => {
    const {
      limitData
    } = permissionsExtraData;
    const limitTooltip = getLimitReachedDisabledTooltipKey({
      limitData,
      crmObjects,
      canBeDisabledDueToMultiLangLimits: true
    });
    return /*#__PURE__*/_jsx(DisabledDueToLimitsTooltip, {
      langKey: limitTooltip,
      multiLangGroupSizeLimit: limitData.multiLangGroupSizeLimit
    });
  }
};
const CONTENT_CONVERT_TO_LANGUAGE_GROUP_PRIMARY = {
  id: CONTENT_ACTION_IDS.CONVERT_TO_LANGUAGE_GROUP_PRIMARY,
  name: getActionName(CONTENT_ACTION_IDS.CONVERT_TO_LANGUAGE_GROUP_PRIMARY),
  tableRowActionGroup: ROW_ACTION_GROUPS.MULTI_LANG,
  ModalOrPanel: AsyncConvertToLanguageGroupPrimaryModal,
  displayPermissions: {
    custom: ({
      crmObjects
    }) => {
      return crmObjects.length > 0 && contentIsTranslation(crmObjects[0]);
    }
  }
};
const CONTENT_REMOVE_FROM_LANGUAGE_GROUP = {
  id: CONTENT_ACTION_IDS.REMOVE_FROM_LANGUAGE_GROUP,
  name: getActionName(CONTENT_ACTION_IDS.REMOVE_FROM_LANGUAGE_GROUP),
  tableRowActionGroup: ROW_ACTION_GROUPS.MULTI_LANG,
  ModalOrPanel: AsyncRemoveFromLanguageGroupModal,
  displayPermissions: {
    custom: ({
      crmObjects
    }) => {
      return crmObjects.length > 0 && contentIsTranslation(crmObjects[0]);
    }
  }
};
const CONTENT_ARCHIVE = {
  id: CONTENT_ACTION_IDS.ARCHIVE,
  name: getActionName(CONTENT_ACTION_IDS.ARCHIVE),
  tableRowActionGroup: ROW_ACTION_GROUPS.ADVANCED,
  BulkInlineActionIcon: ArchiveIcon,
  isAvailableAsBulkAction: true,
  ModalOrPanel: AsyncArchiveModal,
  displayPermissions: {
    custom: ({
      crmObjects,
      isBulkAction
    }) => {
      return isBulkAction ? crmObjects.some(crmObject => !contentIsArchived(crmObject)) : !contentIsArchived(crmObjects[0]);
    }
  },
  enablePermissions: {
    custom: ({
      isBulkAction,
      crmObjects
    }) => {
      if (isBulkAction) {
        return getIsEntireMlangGroupSelected(crmObjects);
      }
      return true;
    }
  },
  DisabledTooltipContent: () => /*#__PURE__*/_jsx(DisabledBulkActionTooltip, {
    langKey: "content-management-actions-lib.tooltips.disabledBulkActions.archive"
  })
};
const CONTENT_UNARCHIVE = {
  id: CONTENT_ACTION_IDS.UNARCHIVE,
  name: getActionName(CONTENT_ACTION_IDS.UNARCHIVE),
  tableRowActionGroup: ROW_ACTION_GROUPS.ADVANCED,
  BulkInlineActionIcon: UnarchiveIcon,
  isAvailableAsBulkAction: true,
  ModalOrPanel: AsyncUnarchiveModal,
  displayPermissions: {
    custom: ({
      crmObjects
    }) => crmObjects.some(contentIsArchived)
  },
  enablePermissions: {
    custom: ({
      isBulkAction,
      crmObjects
    }) => {
      if (isBulkAction) {
        return getIsEntireMlangGroupSelected(crmObjects);
      }
      return true;
    }
  },
  DisabledTooltipContent: () => /*#__PURE__*/_jsx(DisabledBulkActionTooltip, {
    langKey: "content-management-actions-lib.tooltips.disabledBulkActions.unarchive"
  })
};
const CONTENT_DELETE = {
  id: CONTENT_ACTION_IDS.DELETE,
  name: getActionName(CONTENT_ACTION_IDS.DELETE),
  tableRowActionGroup: ROW_ACTION_GROUPS.ADVANCED,
  BulkInlineActionIcon: DeleteIcon,
  isAvailableAsBulkAction: true,
  ModalOrPanel: props => {
    const {
      crmObjects
    } = props;
    if (crmObjects.length === 1 && !contentIsTranslation(crmObjects[0]) && getHasMultilangVariations(crmObjects[0])) {
      return /*#__PURE__*/_jsx(MultiStepModals, Object.assign({}, props, {
        ModalsToRender: [AsyncSwitchPrimaryLanguageModal, AsyncDeleteModal]
      }));
    }
    return /*#__PURE__*/_jsx(AsyncDeleteModal, Object.assign({}, props));
  },
  enablePermissions: {
    custom: ({
      crmObjects,
      isBulkAction
    }) => {
      return isBulkAction ? !getHasCrmObjectsWithOnlyPrimarySelected(crmObjects) : true;
    }
  },
  DisabledTooltipContent: () => /*#__PURE__*/_jsx(DisabledBulkActionTooltip, {
    langKey: "content-management-actions-lib.tooltips.disabledBulkActions.delete"
  })
};
const CONTENT_DELETE_LANGUAGE_GROUP = {
  id: CONTENT_ACTION_IDS.DELETE_LANGUAGE_GROUP,
  name: getActionName(CONTENT_ACTION_IDS.DELETE_LANGUAGE_GROUP),
  tableRowActionGroup: ROW_ACTION_GROUPS.ADVANCED,
  ModalOrPanel: AsyncDeleteModal,
  displayPermissions: {
    custom: ({
      crmObjects
    }) => {
      return crmObjects.length > 0 && contentHasTranslations(crmObjects[0]);
    }
  }
};
const CONTENT_PUBLISHING_OPTIONS = {
  id: CONTENT_ACTION_IDS.PUBLISHING_OPTIONS,
  name: getActionName(CONTENT_ACTION_IDS.PUBLISHING_OPTIONS),
  tableRowActionGroup: ROW_ACTION_GROUPS.ADVANCED,
  ModalOrPanel: AsyncPublishingOptionsModal,
  isAvailableAsBulkAction: true,
  BulkInlineActionIcon: PublishIcon,
  enablePermissions: {
    custom: ({
      isBulkAction,
      permissionsExtraData,
      crmObjects
    }) => {
      if (!isBulkAction && permissionsExtraData && permissionsExtraData.limitData) {
        const limitTooltip = getLimitReachedDisabledTooltipKey({
          limitData: permissionsExtraData.limitData,
          crmObjects,
          canBeDisabledDueToMultiLangLimits: true,
          shouldDisableIfMultiLangLimitIsReachedButNotExceeded: true
        });
        return !limitTooltip;
      }
      return true;
    }
  },
  DisabledTooltipContent: ({
    crmObjects,
    permissionsExtraData
  }) => {
    const {
      limitData
    } = permissionsExtraData;
    const limitTooltip = getLimitReachedDisabledTooltipKey({
      limitData,
      crmObjects,
      canBeDisabledDueToMultiLangLimits: true,
      shouldDisableIfMultiLangLimitIsReachedButNotExceeded: true
    });
    return /*#__PURE__*/_jsx(DisabledDueToLimitsTooltip, {
      langKey: limitTooltip,
      multiLangGroupSizeLimit: limitData.multiLangGroupSizeLimit
    });
  }
};
const CONTENT_UNPUBLISHING_OPTIONS = {
  id: CONTENT_ACTION_IDS.UNPUBLISHING_OPTIONS,
  name: getActionName(CONTENT_ACTION_IDS.UNPUBLISHING_OPTIONS),
  tableRowActionGroup: ROW_ACTION_GROUPS.ADVANCED,
  ModalOrPanel: AsyncUnpublishingOptionsModal,
  isAvailableAsBulkAction: true,
  BulkInlineActionIcon: UnpublishIcon,
  displayPermissions: {
    custom: ({
      crmObjects,
      isBulkAction
    }) => {
      if (!isBulkAction && crmObjects.length > 0) {
        return contentIsPublished(crmObjects[0]) || contentIsScheduled(crmObjects[0]);
      }
      return true;
    }
  },
  enablePermissions: {
    custom: ({
      crmObjects,
      isBulkAction
    }) => {
      if (!isBulkAction) {
        return true;
      }
      return crmObjects.some(crmObject => contentIsPublished(crmObject));
    }
  },
  DisabledTooltipContent: () => /*#__PURE__*/_jsx(DisabledBulkActionTooltip, {
    langKey: "content-management-actions-lib.tooltips.disabledBulkActions.unpublish"
  })
};
const CONTENT_ASSIGN_PERMISSIONS = {
  id: CONTENT_ACTION_IDS.ASSIGN_PERMISSIONS,
  name: getActionName(CONTENT_ACTION_IDS.ASSIGN_PERMISSIONS),
  tableRowActionGroup: ROW_ACTION_GROUPS.ENTERPRISE,
  ModalOrPanel: AsyncAssignPermissionsPanel,
  isAvailableAsBulkAction: true,
  BulkInlineActionIcon: ListsIcon,
  displayPermissions: {
    custom: ({
      scopes,
      crmObjects,
      permissionsExtraData
    }) => {
      if (crmObjects.length > 0) {
        const crmObject = crmObjects[0];
        const teamPerms = getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.TEAM_PERMS, []);
        const userPerms = getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.USER_PERMS, []);
        const teams = permissionsExtraData && permissionsExtraData.teams ? permissionsExtraData.teams : [];
        const teamsDataAvailable = permissionsExtraData ? permissionsExtraData.teamsRequestStatus === RequestStatuses.SUCCEEDED : false;
        return !contentIsTranslation(crmObject) && scopes.includes('teams-content-partitioning') && (scopes.includes('content-team-assignment') || teamsDataAvailable && canAssignTeamsAsNonAdmin(teamPerms, userPerms, teams));
      }
      return false;
    }
  },
  enablePermissions: {
    custom: ({
      isBulkAction,
      crmObjects
    }) => {
      if (isBulkAction) {
        return getIsEntireMlangGroupSelected(crmObjects);
      }
      return true;
    }
  }
};
const CONTENT_RUN_A_TEST = {
  id: CONTENT_ACTION_IDS.RUN_A_TEST,
  name: getActionName(CONTENT_ACTION_IDS.RUN_A_TEST),
  tableRowActionGroup: ROW_ACTION_GROUPS.ENTERPRISE
};
const CONTROL_AUDIENCE_ACCESS = {
  id: CONTENT_ACTION_IDS.CONTROL_AUDIENCE_ACCESS,
  name: getActionName(CONTENT_ACTION_IDS.CONTROL_AUDIENCE_ACCESS),
  tableRowActionGroup: ROW_ACTION_GROUPS.ADVANCED,
  isAvailableAsBulkAction: true,
  BulkInlineActionIcon: EditIcon,
  ModalOrPanel: AsyncContentAccessControlPanel
};
const EDIT_CAMPAIGN = {
  id: CONTENT_ACTION_IDS.EDIT_CAMPAIGN,
  name: getActionName(CONTENT_ACTION_IDS.EDIT_CAMPAIGN),
  tableRowActionGroup: Number.MAX_SAFE_INTEGER,
  displayPermissions: {
    custom: ({
      permissionsExtraData
    }) => permissionsExtraData === null || permissionsExtraData === void 0 ? void 0 : permissionsExtraData.objectTypeHasCampaignsAccess
  },
  isAvailableAsBulkAction: false,
  TableRowCustomActionButton: () => {
    const {
      crmObject
    } = useAssetActions();
    return /*#__PURE__*/_jsx(EditCampaignAction, {
      objectType: getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.OBJECT_TYPE),
      assetId: getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.CRM_OBJECT_ID)
    });
  }
};
export const ContentActions = {
  [CONTENT_EDIT.id]: CONTENT_EDIT,
  [CONTENT_CLONE.id]: CONTENT_CLONE,
  [CONTENT_VIEW.id]: CONTENT_VIEW,
  [CONTENT_DETAILS.id]: CONTENT_DETAILS,
  [CONTENT_ARCHIVE.id]: CONTENT_ARCHIVE,
  [CONTENT_UNARCHIVE.id]: CONTENT_UNARCHIVE,
  [CONTENT_ADD_TO_LANGUAGE_GROUP.id]: CONTENT_ADD_TO_LANGUAGE_GROUP,
  [CONTENT_CREATE_LANGUAGE_VARIANT.id]: CONTENT_CREATE_LANGUAGE_VARIANT,
  [CONTENT_CONVERT_TO_LANGUAGE_GROUP_PRIMARY.id]: CONTENT_CONVERT_TO_LANGUAGE_GROUP_PRIMARY,
  [CONTENT_REMOVE_FROM_LANGUAGE_GROUP.id]: CONTENT_REMOVE_FROM_LANGUAGE_GROUP,
  [CONTENT_DELETE.id]: CONTENT_DELETE,
  [CONTENT_DELETE_LANGUAGE_GROUP.id]: CONTENT_DELETE_LANGUAGE_GROUP,
  [CONTENT_PUBLISHING_OPTIONS.id]: CONTENT_PUBLISHING_OPTIONS,
  [CONTENT_UNPUBLISHING_OPTIONS.id]: CONTENT_UNPUBLISHING_OPTIONS,
  [CONTENT_RUN_A_TEST.id]: CONTENT_RUN_A_TEST,
  [CONTENT_ASSIGN_PERMISSIONS.id]: CONTENT_ASSIGN_PERMISSIONS,
  [CONTROL_AUDIENCE_ACCESS.id]: CONTROL_AUDIENCE_ACCESS,
  [EDIT_CAMPAIGN.id]: EDIT_CAMPAIGN
};